// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notes-print_wrapper__3xWBV","title":"notes-print_title__jOPNP"};